import { SelectOption } from '@anm/components/select/Select';
import { useCallback, useState } from 'react';

// import enum from /shared folder crashes the app
export enum BrandFileTypes {
  upload = 'upload',
  stock = 'stock',
  project = 'project'
}

export enum BrandFileCategories {
  overlay = 'overlay',
  background = 'background',
  audio = 'audio',
  video = 'video'
}

const useBrandTypes = () => {
  const [selectedCategory, selectCategory] = useState<BrandFileCategories>(BrandFileCategories.background);

  const handleSelectType = useCallback(
    ({ label }: SelectOption<string>) => selectCategory(BrandFileCategories[label as BrandFileCategories]),
    []
  );

  const brandTypeOptions: SelectOption<string>[] = Object.keys(BrandFileCategories)
    .filter(c => c !== BrandFileCategories.audio)
    .map(c => ({
      label: c
    }));

  const currentBrandTypeOption: SelectOption<string> = { label: selectedCategory };

  return [selectedCategory, currentBrandTypeOption, brandTypeOptions, handleSelectType] as const;
};

export default useBrandTypes;
